import httpClient from './http-client';
import type {
  WalkdownApiResponse,
  GetWalkdownsParams,
  WalkdownChartResponse,
  WalkdownDevicesResponse
} from '@/types/walkdown';

export default class WalkdownService {
  private baseApiEndpoint = '/api/wds';
  private idToken: string | undefined = '';
  private accessToken: string | undefined = '';

  constructor(idToken?: string | undefined, accessToken?: string | undefined) {
    this.idToken = idToken;
    this.accessToken = accessToken;
    this.baseApiEndpoint = import.meta.env.VITE_BYPASS_PROXY === 'true' 
                            ? '' : this.baseApiEndpoint;
  }
  async getWalkdowns(params: GetWalkdownsParams): Promise<WalkdownApiResponse | null> {
    try {
      const response = await httpClient.get(`${this.baseApiEndpoint}/walkdowns`, {
        params: {
          gdm_customer_number: params.gdm_customer_number,
          search: params.search
        }
      });
      return response.data;
    } catch (error) {
      console.error('Get Walkdowns API Error:', error);
      return null;
    }
  }

  async getWalkdownCharts(walkdown_ids: string[]): Promise<WalkdownChartResponse | null> {
    try {
      const response = await httpClient.get(`${this.baseApiEndpoint}/walkdowns/chart`, {
        params: {
          walkdown_id: walkdown_ids.join(',')
        }
      });
      return response.data;
    } catch (error) {
      console.error('Get Walkdown Charts Error:', error);
      return null;
    }
  }

  async getWalkdownDevices(
    walkdown_ids: string[], 
    size: number = 1000
  ): Promise<WalkdownDevicesResponse | null> {
    try {
      const response = await httpClient.get(`${this.baseApiEndpoint}/walkdowns/devices`, {
        params: {
          walkdown_ids: walkdown_ids.join(','),
          size: size,
          limit: size,
          page_size: size,
          per_page: size
        }
      });
      return response.data;
    } catch (error) {
      console.error('Get Walkdown Devices Error:', error);
      return null;
    }
  }

  async linkDevice(device_guid: string, walkdown_device_id: string): Promise<any> {
    try {
      const response = await httpClient.post(
        `${this.baseApiEndpoint}/walkdowns/device/link`,
        {
          device_guid,
          walkdown_device_id
        }
      );
      return response.data;
    } catch (error) {
      console.error('Link Device Error:', error);
      throw error;
    }
  }

  async unlinkDevice(walkdown_device_id: string): Promise<any> {
    try {
      const response = await httpClient.post(
        `${this.baseApiEndpoint}/walkdowns/device/unlink`,
        {
          walkdown_device_id
        }
      );
      return response.data;
    } catch (error) {
      console.error('Unlink Device Error:', error);
      throw error;
    }
  }
}
